import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowVideoConverter extends CmsConverterService<PanelRowVideoData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      caption: formData.st_text_small ?? defaultTextInput,
      captionOverlay: formData.st_caption_text_overlay ?? defaultTextInput,
      descriptionOverlay: formData.st_description_text_overlay ?? defaultTextInput,
      text: formData.st_text_empty?.value ? defaultTextInput : (formData.st_text ?? defaultTextInput),
      flowingText: !!formData.st_flowing_text?.value ?? false,
      videoId: formData.st_video ?? '',
      captionEmpty: formData.st_text_small_empty?.value ?? false,
      textEmpty: formData.st_text_empty?.value ?? false,
      listClass: ''
    }
  }
}

export const PANEL_ROW_VIDEO_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowVideoData>>('PanelRowVideoConverter')

export interface PanelRowVideoData extends ConvertedComponentData {
  caption: TextInput;
  captionOverlay: TextInput;
  descriptionOverlay: TextInput;
  text: TextInput;
  flowingText: boolean;
  videoId: string;
  captionEmpty: boolean;
  textEmpty: boolean;
  listClass: string;
}
